module.exports = __webpack_public_path__ + "static/img/szafa_9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/_kopia/szafa_9.jpg
// module id = OAI7
// module chunks = 0